import { NgModule } from '@angular/core';

import { CustomControlMessagesComponent } from './control-messages.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [CustomControlMessagesComponent],
  imports: [CommonModule],
  exports: [CustomControlMessagesComponent]
})
export class ValidationModule { }
